export default "__VITE_ASSET__C6TPM6y2__"